import React, { useState, useEffect } from "react";
import { Wheel } from "react-custom-roulette";
import { useDispatch, useSelector } from "react-redux";
import { fetchAPI } from "../service/Encrtyption";
import { useNavigate, useParams } from "react-router-dom";
import CustomModal from "../modal";
import { useTranslation } from "react-i18next";
import SuccessIcon from "../../../src/assets/images/successIcon.png";
import spinBg from "../../../src/assets/images/spin-bg.png";
import spinInnerBg from "../../../src/assets/images/spin-inner.png";
import DelegateBottle from "../../../src/assets/images/delegateBottle.svg";
import { Loader } from "../loader";
import { giftImageUrlFun, spinStatus, setSecondaryMessageAction } from "../auth/redux/store";
import ReactGA from 'react-ga4';
import { convertMediaUrls } from "../../utils/authenticatedImages";

const CustomRoulette = ({ wheelItems, stopPrizeNumber, closeModal }) => {
  const [mustSpin, setMustSpin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rewardUpdateModal, setRewardUpdateModal] = useState(false);
  const [GiftImageURL, setGiftImageURL] = useState('');
  const [secondaryMessage, setSecondaryMessage] = useState('');
  const [spinDataCashRewards, setSpinDataCashRewards] = useState('');

  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const [stopPrizeNumberNew, setStopPrizeNumberNew] = useState(stopPrizeNumber);
  const spinValue = useSelector((state) => state?.spinValue);
  const genunityData = useSelector((state) => state?.genunityData);
  const cropData = useSelector((state) => state?.cropData);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const outerBorderColor = '#3D1D50';
  const outerBorderWidth = 27;
  const innerBorderColor = '#F16922';
  const innerBorderWidth = 15;
  const innerRadius = 0;
  // const radiusLineColor = '#44A7EB';
  const radiusLineWidth = 0;
  const currentLanguage = i18n.language;
  // console.log("currentLanguage+" + currentLanguage);
  const { cashRewards } = genunityData;
  const data = wheelItems?.map((item) => {
    if (item?.imageUrl && item?.imageUrl?.trim() !== "") {
      return {
        option: "", // Empty string because we want to render image
        style: { backgroundColor: item?.colorCode },
        image: {
          uri: item?.imageUrl,
          offsetX: 20,
          offsetY: 100,
          sizeMultiplier: 0.9,
          landscape: false,
        },
      };
    } else {
      // Render text (item name) if imageUrl is empty
      return {
        option: item?.name, // Use item.name directly as the option
        style: {
          backgroundColor: item?.colorCode,
          fontSize: 30,
          fontWeight: "bold",
          textAlign: "center",
          color: "#ffffff",
          maxWidth: "100%", // Adjust max-width as needed
          wordWrap: "break-word", // Allow long words to break
          overflowWrap: "break-word", // Alternative for word wrapping
          whiteSpace: "normal", // Ensure text wraps within the container
        },
      };
    }
  });
  const mobileNumber = sessionStorage.getItem('mbn');

  // Define handleSpin function to be called when necessary
  const handleSpin = async () => {
    // debugger;
    setLoading(true);

    ReactGA.event({
      category: 'User Spin Wheel Clicked',
      label: 'Spin Wheel Button',
      action: 'Clicked Spin Wheel Button',
    });

    const updatedJsonData = {
      ...genunityData,
      destinationURL: "/updateStrongarmSpinStatus",
      secondaryRewardMsg: "",
      rewardPoints: genunityData.rewardPoints.toString(),
      cashRewards: genunityData.cashRewards.toString(),
      selectedCropName: cropData
    };
    // debugger;

    console.log(JSON.stringify(updatedJsonData) + "updatedJsonData");
    try {
      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL,
        updatedJsonData,
        {
          appLangCode: currentLanguage,
          deviceType: "WEB",
          mobileNumber: mobileNumber,
          deviceId: "WEB",
        }
      );
 
      const apiResponse = JSON.parse(responseData); 
      const jsonReposneData = await convertMediaUrls(apiResponse); 
      console.log(JSON.stringify(responseData) + "SPIN DATA"); 
      const announcementMessage = jsonReposneData.primaryRewardMsg;
      setSecondaryMessage(announcementMessage);
      dispatch(setSecondaryMessageAction(announcementMessage));
      setSpinDataCashRewards(jsonReposneData?.cashRewards);
      if (jsonReposneData.statusCode === "200") {
        //  debugger;
        setMustSpin(spinValue);
        if (jsonReposneData.congratsImageUrl != '') {
          dispatch(giftImageUrlFun(jsonReposneData.congratsImageUrl))
        }
        // const selectedItem = jsonReposneData.wheelStoppingIndex - 1;
        // setStopPrizeNumberNew(selectedItem); // Set the stopPrizeNumber based on the item's id
        const wheelStoppingIndex = parseInt(jsonReposneData.wheelStoppingIndex, 10);

        if (!isNaN(wheelStoppingIndex) && wheelStoppingIndex !== undefined && wheelStoppingIndex > 0) {
          const selectedItem = wheelStoppingIndex - 1; // This now ensures selectedItem is never -1
          //  console.log("Selected Item:", selectedItem);

          if (selectedItem >= 0 && selectedItem < wheelItems.length) {
            setStopPrizeNumberNew(selectedItem);
          } else {
            console.error("Selected Item is out of valid range:", selectedItem);
            // Handle out-of-range scenario
          }
        } else {
          setStopPrizeNumberNew(0);
          console.error("Invalid or zero wheelStoppingIndex received:", wheelStoppingIndex);
          // Handle invalid or zero index scenario
        }
      }
    } catch (error) {
      console.error("Error fetching API:", error);
    } finally {
      setLoading(false);
    }
  };
  // Call handleSpin when mustSpin state changes
  useEffect(() => {
    if (spinValue) {
      handleSpin();
    }
  }, [spinValue]);

  const handleSpinningStop = () => {
    dispatch(spinStatus(false));
    console.log(spinDataCashRewards + "spinDataCashRewards");
    if (spinDataCashRewards > 0) {
      navigate(`/${currentLanguage}/Reward`);
    } else {
      closeModal();
      setRewardUpdateModal(true);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div style={{
        textAlign: "center",
        position: 'relative',
        backgroundImage: `url(${spinBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '14px 11px'
      }}>

        <Wheel
          mustStartSpinning={mustSpin}
          prizeNumber={stopPrizeNumberNew}
          data={data}
          outerBorderColor={""}
          outerBorderWidth={outerBorderWidth}
          innerRadius={innerRadius}
          innerBorderColor={innerBorderColor}
          innerBorderWidth={innerBorderWidth}
          // radiusLineColor={radiusLineColor}
          radiusLineWidth={radiusLineWidth}
          onStopSpinning={() => {
            handleSpinningStop();
            setMustSpin(false);
          }}
        />

        <div className="wheeldotsround">
          <img src={spinInnerBg} alt="spinInnerBg" className="w-100" />
        </div>
        <CustomModal
          id={"rewardUpdateModal"}
          title={""}
          content={
            <>
              <img src={SuccessIcon} alt="SuccessIcon" className="succesIcon" />
              <img src={GiftImageURL} alt="GiftImageURL" />
              <p className="congratulationsText">{t("congratulations")}</p>
              <p className="rewardText">{t("updatesOnReward")}</p>
            </>
          }
          show={rewardUpdateModal}
          onHide={() => setRewardUpdateModal(false)}
        />
      </div>
    </>
  );
};

export default CustomRoulette;
